import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";

import { Disclosure } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import MarkdownWrapper from "@/components/markdownWrapper";

export const query = graphql`
  fragment FaqCenteredAccordionData on StrapiComponentFaqCenteredAccordion {
    topic
    title
    questions {
      question
      answer
    }
  }
`;

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function CenteredAccordion({ data }) {
  if (!data) {
    return <template />;
  }
  return (
    <div className="bg-background-off-white">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 sm:py-16 lg:px-8">
        <div className="mx-auto max-w-3xl divide-y-2 divide-divide-light">
          <div>
            {data.topic && (
              <h3 className="block text-center text-base font-semibold uppercase tracking-wide text-text-secondary">
                <MarkdownWrapper text={data.topic} />
              </h3>
            )}
            {data.title && (
              <h2 className="text-center text-3xl font-extrabold text-text-primary sm:text-4xl">
                <MarkdownWrapper text={data.title} />
              </h2>
            )}
          </div>
          {Boolean(data.questions?.length) && (
            <dl className="mt-6 space-y-6 divide-y divide-divide-light">
              {data.questions.map((faq, index) => (
                <Disclosure as="div" key={index} className="pt-6">
                  {({ open }) => (
                    <>
                      <dt className="text-lg">
                        <Disclosure.Button className="flex w-full items-start justify-between text-left text-text-secondary">
                          <span className="font-medium text-text-secondary-dark">
                            <MarkdownWrapper text={faq.question} />
                          </span>
                          <span className="ml-6 flex h-7 items-center">
                            <ChevronDownIcon
                              className={classNames(
                                open ? "-rotate-180" : "rotate-0",
                                "h-6 w-6 transform"
                              )}
                              aria-hidden="true"
                            />
                          </span>
                        </Disclosure.Button>
                      </dt>
                      <Disclosure.Panel as="dd" className="mt-2 pr-12">
                        <MarkdownWrapper
                          text={faq.answer}
                          markdownClassName="text-base text-text-secondary"
                          replaceParagraph={false}
                        />
                      </Disclosure.Panel>
                    </>
                  )}
                </Disclosure>
              ))}
            </dl>
          )}
        </div>
      </div>
    </div>
  );
}

CenteredAccordion.propTypes = {
  data: PropTypes.object,
};

export default CenteredAccordion;
